import { compareDesc } from 'date-fns';
import { Observable } from 'rxjs';
import { mapTo, tap } from 'rxjs/operators';

import { catchErrorLogRet } from '../../../common/rest.operators';
import { CacheDateItem } from '../../../insight/performance-data/cache-date.pd.model';
import { PerformanceDataService } from '../../../insight/performance-data/performance-data.service';
import { epicDependencies } from '../../../store';
import { currentBuilderState } from '../builder.state';

export function loadCacheDates(): Observable<void> {
    const performanceDataService =
        epicDependencies.injector.get<PerformanceDataService>(
            PerformanceDataService,
        );

    return performanceDataService.listCacheDates({}).pipe(
        catchErrorLogRet([]),
        tap((ret) => {
            _loadCacheDates(ret);
        }),
        mapTo(null),
    );
}

function _loadCacheDates(ret: CacheDateItem[]): void {
    const state = currentBuilderState();

    ret.forEach((cd) => {
        cd.startDate = cd.startDate == null ? null : new Date(cd.startDate);
        cd.endDate = cd.endDate == null ? null : new Date(cd.endDate);
    });
    ret.sort((a, b) => compareDesc(a.endDate, b.endDate));

    state.cacheDatesMap = {};
    state.periodTypes?.forEach((pt) => {
        state.cacheDatesMap[pt.id] = ret.filter(
            (cd) => cd.periodType === pt.id,
        );
    });
}
